import React from 'react';
import {
    Grid,
    TextField,
    Button
} from '@material-ui/core';

interface IsinDataApiAccount {
    first_name: string;
    last_name: string;
    firm: string;
    email: string;
    status: string;
}

interface AddAccountFormProps {
    newAccount: IsinDataApiAccount;
    statusOptions: string[];
    onChange: (field: keyof IsinDataApiAccount) => (e: React.ChangeEvent<HTMLInputElement>) => void;
    onAdd: () => void;
}

const AddAccountForm: React.FC<AddAccountFormProps> = ({ newAccount, statusOptions, onChange, onAdd }) => (
    <Grid container spacing={2} style={{ marginTop: 30 }}>
        {['first_name', 'last_name', 'firm', 'email', 'status'].map((field) => (
            <Grid item key={field}>
                {field === 'status' ? (
                    <TextField
                        select
                        label="Status"
                        value={newAccount.status}
                        onChange={onChange('status')}
                        SelectProps={{ native: true }}
                    >
                        {statusOptions.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </TextField>
                ) : (
                    <TextField
                        label={field.replace('_', ' ')}
                        value={(newAccount as any)[field]}
                        onChange={onChange(field as keyof IsinDataApiAccount)}
                    />
                )}
            </Grid>
        ))}
        <Grid item>
            <Button variant="contained" color="primary" onClick={onAdd}>
                Add
            </Button>
        </Grid>
    </Grid>
);

export default AddAccountForm;
